export enum AmmendSheqManagerLoadingState {
  LoadingSheqManager = 'Loading SHEQ Manager Details...',
  UpdatingSheqManager = 'Saving Changes...',
  ReassigningDepots = 'Re-Assigning Depots...',
  RemovingSheqManager = 'Removing SHEQ Manager...'
}